<template>
  <div
    class="custom-box-shadow flex h-full w-auto animate-pulse flex-col justify-between gap-4 rounded-xl border border-light-gray p-4 md:w-full lg:rounded"
  >
    <div class="flex flex-row justify-between">
      <div class="flex flex-col gap-2">
        <div class="h-5 w-32 rounded bg-steel-200" />
        <div class="h-3 w-24 rounded bg-steel-100" />
      </div>
      <div class="h-7 w-20 rounded-full bg-steel-200" />
    </div>

    <div class="flex flex-col gap-1">
      <div class="h-3 w-24 rounded bg-steel-100" />
      <div class="h-4 w-40 rounded bg-steel-200" />
    </div>

    <div class="flex flex-col gap-1">
      <div class="h-3 w-24 rounded bg-steel-100" />
      <div class="h-4 w-32 rounded bg-steel-200" />
    </div>

    <div class="flex justify-between gap-4">
      <div class="flex flex-col gap-1">
        <div class="h-3 w-16 rounded bg-steel-100" />
        <div class="h-4 w-24 rounded bg-steel-200" />
      </div>
      <div class="flex flex-col gap-1">
        <div class="h-3 w-16 rounded bg-steel-100" />
        <div class="h-4 w-24 rounded bg-steel-200" />
      </div>
      <div class="flex flex-col gap-1">
        <div class="h-3 w-20 rounded bg-steel-100" />
        <div class="h-4 w-24 rounded bg-steel-200" />
      </div>
    </div>

    <div class="flex justify-between gap-4">
      <div class="flex flex-col gap-1">
        <div class="h-3 w-16 rounded bg-steel-100" />
        <div class="h-4 w-24 rounded bg-steel-200" />
      </div>
      <div class="flex flex-col gap-1">
        <div class="h-3 w-20 rounded bg-steel-100" />
        <div class="h-4 w-24 rounded bg-steel-200" />
      </div>
    </div>

    <div class="flex flex-col gap-2">
      <div class="h-3 w-24 rounded bg-steel-100" />
      <div class="h-4 w-32 rounded bg-steel-200" />
    </div>

    <div>
      <div class="h-10 w-full rounded-xl bg-steel-100" />
    </div>
  </div>
</template>
